// extracted by mini-css-extract-plugin
export default {"root":"Overview-root_JC7Sg"};